import { BASIC_AUTH_PASS, BASIC_AUTH_USER } from '@/src/lib/core/config';

export function getBasicAuthCredentials(): { username: string; password: string } | null {
  if (!BASIC_AUTH_PASS || !BASIC_AUTH_USER) {
    return null;
  }

  return { username: BASIC_AUTH_USER, password: BASIC_AUTH_PASS };
}
